import { Api } from '../api';
import { IResponseWorkflow, IDetalheWorkflow, ICreateWorkflow, IRespFluxoValidacao, IResponseLogWorkflow } from 'shared/types';
import { ReactFlowJsonObject } from 'react-flow-renderer';


const getAll = async (org: number, filter = ''): Promise<IResponseWorkflow | Error> => {
  try {
    const { data, status } = await Api.get(`/Workflow/Orgs/${org}/${filter !== '' ? '?' : ''}${filter}`);
    if (data) {
      return data.retornoPagina;
    }
    if (status === 204) {
      return {rows:[],count: 0};
    }

   
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};

const getAllLogs = async (filter = ''): Promise<IResponseLogWorkflow | Error> => {
  try {
    const { data, status } = await Api.get(`/WorkFlowLog${filter !== '' ? '?' : ''}${filter}`);
    if (data) {
      return data.retornoPagina;
    }
    if (status === 204) {
      return {rows:[],count: 0};
    }

    return new Error('Erro ao listar os registros.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};

const getById = async (org: number, id: number): Promise<IDetalheWorkflow | Error> => {
  try {
    const { data } = await Api.get(`/Orgs/${org}/Workflow/${id}`);

    if (data) {
      return data;
    }

    return new Error('Erro ao consultar o registro.');
  } catch (error) {

    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao consultar o registro.');
  }
};

const create = async (org: number, dados: ICreateWorkflow): Promise<number | Error> => {
  try {
    const { data, status } = await Api.post(`/Orgs/${org}/Workflow`, dados);
    if (data) {
      const { erro } = data;
      if (erro) {
        return new Error(`${erro.mensagem} - ${erro.descricao}`);
      }
      if (status > 299) {
        return new Error(data);
      }
      return data.IdWorkflow;
    }
    return new Error('Erro ao criar o registro.');
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao criar o registro.');
  }
};

const updateById = async (org: number, id: number, dados: ICreateWorkflow,): Promise<void | Error> => {
  try {
    const { data, status } = await Api.put(`/Orgs/${org}/Workflow/${id}`, dados);
    const { erro } = data;
    if (erro) {
      return new Error(`${erro.mensagem} - ${erro.descricao}`);
    }
    if (status > 299) {
      return new Error(data);
    }
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao atualizar o registro.');
  }
};

const updateFluxo = async (org: number, id: number, dados: ReactFlowJsonObject<any, any>,): Promise<void | Error> => {
  try {
    const { data, status } = await Api.patch(`/Orgs/${org}/Workflow/${id}/fluxos`, dados);
    const { erro } = data;
    if (erro) {
      return new Error(`${erro.mensagem} - ${erro.descricao}`);
    }
    if (status > 299) {
      return new Error(data);
    }
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao atualizar o registro.');
  }
};

const getFluxo = async (org: number, id: number): Promise<(ReactFlowJsonObject<any, any> & {StatusWorkflow: string,DhPeriodoInicio: string,  DhPeriodoFim: string}) | Error> => {
  try {
    const { data, status } = await Api.get(`/Orgs/${org}/Workflow/${id}/fluxos`);
    const { erro } = data;
    if (erro) {
      return new Error(`${erro.mensagem} - ${erro.descricao}`);
    }
    if (status > 299) {
      return new Error(data);
    }
    return data;
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao atualizar o registro.');
  }
};

const deleteById = async (org: number, id: number): Promise<void | Error> => {
  try {
    const { data, status } = await Api.delete(`/Orgs/${org}/Workflow/${id}`);
    const { erro } = data;
    if (erro) {
      return new Error(`${erro.mensagem} - ${erro.descricao}`);
    }
    if (status > 299) {
      return new Error(data);
    }
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao apagar o registro.');
  }
};

const validateFluxo = async (org: number, id: number, dados: ReactFlowJsonObject<any, any>, novoStatus: string ): Promise<IRespFluxoValidacao | Error > => {
  try {
    const { data, status } = await Api.post(`/Orgs/${org}/Workflow/${id}/fluxos/validate${novoStatus !== ''?'/':''}${novoStatus}`, dados);
    if (data) {
      const { erro } = data;
      if (erro) {
        return new Error(`${erro.mensagem} - ${erro.descricao}`);
      }
      if (status > 299) {
        return new Error(data);
      }
      return data;
    }
    return new Error('Erro ao validar o registro.');
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao validar o registro.');
  }
};

const updateStatus = async (org: number, id: number, statusAlteracao: string, dados: ReactFlowJsonObject<any, any>,): Promise<string | Error > => {
  try {
    const { data, status } = await Api.put(`/Orgs/${org}/Workflow/${id}/status/${statusAlteracao}`, dados);
    if(status === 200){
      return 'OK';
    }
    if (data) {
      const { erro } = data;
      if (erro) {
        return new Error(`${erro.mensagem} - ${erro.descricao}`);
      }
      if (status > 299) {
        return new Error(data);
      }
      return data;
    }
    return new Error('Erro ao atualizar o registro.');
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao atualizar o registro.');
  }
};

export const WorkflowsService = {
  getAll,
  create,
  getById,
  updateById,
  deleteById,
  updateFluxo,
  getFluxo,
  validateFluxo,
  updateStatus,
  getAllLogs
};

